import type { CatalogItem } from '~/models/common'

export const gameBudget: CatalogItem[] = [
  {
    label: '—',
    value: 1,
  },
  {
    label: '50 – 100k$',
    value: 2,
  },
  {
    label: '100 – 200k$',
    value: 3,
  },
  {
    label: '200 – 350k$',
    value: 4,
  },
  {
    label: '350 – 500k$',
    value: 5,
  },
  {
    label: '500 – 700k$',
    value: 6,
  },
  {
    label: '700 – 1M$',
    value: 7,
  },
  {
    label: '1 – 1.5M$',
    value: 8,
  },
  {
    label: '1.5 – 2M$',
    value: 9,
  },
  {
    label: '>2M$',
    value: 10,
  },
]
